"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCaretLeft = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M48.4 57.49a3.85 3.85 0 0 0 0-5.44l-17-17 17-17a3.85 3.85 0 0 0 0-5.45 3.85 3.85 0 0 0-5.45 0L20.46 35l22.48 22.5a3.85 3.85 0 0 0 5.46-.01z"
  })),
  height: undefined,
  width: undefined
});
IconCaretLeft.displayName = 'IconCaretLeft';
var _default = IconCaretLeft;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/caret-left.js
// module id = 227
// module chunks = 0